const changeArrayAt = (arr: any[], index: number, newVal?: any) => {
  const tmp = [...arr];
  newVal ? tmp.splice(index, 1, newVal) : tmp.splice(index, 1);
  return tmp;
};

export default changeArrayAt;
